









































import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import { VaultFile } from "@scrile/api-provider/dist/api/VaultsProvider";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import InfiniteScroll from "@/components/InfiniteScroll";
import { UsedFilesMap } from "../../types";
import VaultFiles from "../VaultFiles";

const CHECKED_FILE_CLASSES = "vault-file-list__file __checked";

export default defineComponent({
  name: "VaultFilesList",
  components: { InfiniteScroll, BaseButton, BaseIcon, VaultFiles },
  props: {
    vaultFiles: { type: Array as () => VaultFile[], required: true },
    usedFilesMap: { type: Object as () => UsedFilesMap },
    scroll: { type: Boolean },
    multiSelection: { type: Boolean, default: false },
    maxFiles: { type: Number, required: true },
    hideDefaultButtons: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const checkedFiles = ref<Record<string, boolean | undefined>>({});

    const fileClasses = computed(() => {
      return Object.fromEntries(Object.entries(checkedFiles.value).map(i => [i[0], i[1] ? CHECKED_FILE_CLASSES : ""]));
    });
    const emptySelection = computed(() => Object.values(checkedFiles.value).every(i => !i));

    const checkedFileList = computed(() => props.vaultFiles.filter(f => checkedFiles.value[f.id]));
    const onToggle = (id: string) => {
      if (!checkedFiles.value[id] && checkedFileList.value.length >= props.maxFiles && props.maxFiles > 1) return;

      if (props.maxFiles === 1) {
        checkedFiles.value = {
          [id]: !checkedFiles.value[id],
        };
      } else {
        checkedFiles.value = {
          ...checkedFiles.value,
          [id]: !checkedFiles.value[id],
        };
      }
    };

    const isChecked = (id: string) => !!checkedFiles.value[id];

    const onFileCheck = (file: VaultFile) => {
      if (props.multiSelection) {
        onToggle(file.id);
        emit("getCheckedFiles", checkedFileList.value);
      } else {
        emit("select", [file]);
      }
    };

    const onSubmit = () => {
      emit("select", checkedFileList.value);
    };
    const onCancel = () => {
      checkedFiles.value = {};
      emit("cancel");
    };
    emit("hasSelection", false);
    watch(emptySelection, emptySelection => emit("hasSelection", !emptySelection));

    return {
      isChecked,
      onFileCheck,
      fileClasses,
      emptySelection,
      onSubmit,
      onCancel,
      checkedFiles,
      checkedFileList,
    };
  },
});
